import * as React from 'react';

import {
  Dialog,
  FlatButton,
  GridList,
  MenuItem,
  Paper,
  RaisedButton,
  SelectField,
  TextField,
  Toggle,
  IconButton,
  FontIcon,
} from 'material-ui';
import { blue500 } from 'material-ui/styles/colors';
import { List, ListItem } from 'material-ui/List';
import {
  Partner,
  PartnerMeta,
  StudioAppConfig,
  UserEngageNotification,
} from 'glance-datatypes';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { regionFilters, regionNames } from '../Utils';

import JerseyRestApiService from '../JerseyRestApiService';
import { connect } from 'react-redux';

const FILE_UPLOAD_SIZE_LIMIT = 70485760;

const styles = {
  container: {
    width: '80%',
    margin: 'auto',
    marginTop: '50px',
    padding: '20px',
  },
  alertStyle: {
    marginTop: '20px',
  },
  saveButtonStyle: {
    marginTop: '15px',
  },
  dialogContentStyle: {
    width: '400px',
  },
  toggleViewContainer: {
    display: 'flex',
    height: '40px',
    textAlign: 'center',
  },
  activeView: {
    flex: '1',
    background: '#00BCD4',
    padding: '8px',
  },
  inactiveview: {
    flex: '1',
    padding: '8px',
  },
  fileUploaderView: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '25px',
  },
  uploadButton: {
    float: 'right',
    flex: 1,
    minWidth: '120px',
  },
  fileUpload: {
    minWidth: '100px',
  },
  uploadedFilepath: {
    display: 'flex',
    paddingTop: '20px',
  },
  filePathLink: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 3,
  },
  errorTag: {
    color: 'red',
  },
  targetViewText: {
    paddingTop: '10px',
  },
  radioButtonGroup: {
    paddingTop: '45px',
  },
  radioButton: {
    float: 'left',
    width: '50%',
    margim: '10px 0 ',
  },
  ctalinkInput: {
    float: 'left',
    width: '80%',
  },
  ctaIconButton: {
    float: 'left',
    width: '20%',
    marginTop: '25px',
  },
};

const regex = {
  title: {
    checker: /^.{3,}$/,
    errMsg: 'Title should be min 3 characters',
  },
  body: {
    checker: /^.{3,}$/,
    errMsg: 'Body should be min 3 characters',
  },
  image: {
    checker: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
    errMsg: 'Please Enter Valid Image Url',
  },
  urlLink: {
    checker: '^(?!s*$).+',
    errMsg: 'Please Enter a Link Url',
  },
  deeplink: {
    checker: '',
    errMsg: 'Please Enter a GlanceId to Open',
  },
  text: {
    checker: /^.{3,}$/,
    errMsg: 'Text should be min 3 characters',
  },
  link: {
    checker: /^.{1,}$/,
    errMsg: 'Please Enter a Link Url',
  },
};

const activePartners = [
  '16b66d7123dd588670e011bbb88bec9c0a27359c',
  '6c0df13798382e1044a104a8f984edb130b20ce6',
  'ad5b47f7258c6ff30313557f32235fe64f7873a8',
  'bac8164d2982a5afbac64c57b64f9688',
  '0ca8383599b6a1b99fecd5d07ea6d355',
  '439125bff2c51a774d87c95a7d4e460c',
  '6ed915c905737998e3a505688863fede',
  '8294b57a5a4a6227a45e10ab9d71ffb4',
  'a07a917cae67e8a206bf9bdde2da9aed',
  'eee86d7cb6b40eeabd6858f4a88e4374',
  '8aa5e6d1bea2ee2ae3f3f148c70e4cc3',
  '6f7caac7bf84937001342b8f9641d757',
  'd41d8cd98f00b204e9800998ecf8427e',
  'dde1b816a19d16a8b866ff74319d7995',
  '2bea64040f41b17332d7a67fadeae336',
  'fa647c9e01a2defa9fdc483a9a3352d003cb003d'
];

const deepLinkMap = {
  '6c0df13798382e1044a104a8f984edb130b20ce6': [
    {
      name: 'To Open WC',
      value: 'fashiongallery://home',
    },
    {
      name: 'To Open Setting page',
      value: 'fashiongallery://setting',
    },
    {
      name: 'To Open Specific Glance Id',
      value: 'fashiongallery://home?id={glance_id}',
    },
    {
      name: 'To Open Categories',
      value: 'glance://categories',
    },
  ],
  '16b66d7123dd588670e011bbb88bec9c0a27359c': [
    {
      name: 'Settings',
      value:
        'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.SettingsLssActivity',
    },
    {
      name: 'About(for update)',
      value:
        'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.about.AboutDynamicLockActivity',
    },
    {
      name: 'Categories',
      value:
        'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.FollowCategoriesActivity',
    },
    {
      name: 'Reactivation API',
      value: 'dynamiclockscreen://flashpage?from=coaching',
    },
  ],
  '-1': [],
  bac8164d2982a5afbac64c57b64f9688: [
    {
      name: 'Settings',
      value:
        'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.SettingsLssActivity',
    },
    {
      name: 'About(for update)',
      value:
        'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.about.AboutDynamicLockActivity',
    },
    {
      name: 'Categories',
      value:
        'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.FollowCategoriesActivity',
    },
    {
      name: 'Reactivation API',
      value: 'dynamiclockscreen://flashpage?from=coaching',
    },
    {
       name: 'About page',
       value: 'dynamiclockscreen://flashpage?from=about&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.about.AboutDynamicLockActivity',
    },
    {
       name: 'Setting page',
       value: 'dynamiclockscreen://flashpage?from=setting&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.SettingLssActivity',
    },
  ],
  '0ca8383599b6a1b99fecd5d07ea6d355': [
    {
      name: 'To Open WC',
      value: 'fashiongallery://home',
    },
    {
      name: 'To Open Setting page',
      value: 'fashiongallery://setting',
    },
    {
      name: 'To Open Specific Glance Id',
      value: 'fashiongallery://home?id={glance_id}',
    },
    {
      name: 'To Open Categories',
      value: 'glance://categories',
    },
  ],
  '439125bff2c51a774d87c95a7d4e460c': [
    {
      name: 'Settings',
      value:
        'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.SettingsLssActivity',
    },
    {
      name: 'About(for update)',
      value:
        'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.about.AboutDynamicLockActivity',
    },
    {
      name: 'Categories',
      value:
        'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.FollowCategoriesActivity',
    },
  ],
  '6ed915c905737998e3a505688863fede': [
    {
      name: 'Settings',
      value:
        'mygalaxystories://flashpage?from=coaching&package=com.samsung.android.keyguardmgsupdator&activity=com.samsung.android.keyguardmgsupdator.ui.KeyguardMGSSettingsActivity',
    },
    {
      name: 'About(for update)',
      value:
        'mygalaxystories://flashpage?from=coaching&package=com.samsung.android.keyguardmgsupdator&activity=com.samsung.android.keyguardmgsupdator.ui.KeyguardMGSAboutActivity',
    },
    {
      name: 'Categories',
      value:
        'mygalaxystories://flashpage?from=coaching&package=com.samsung.android.keyguardmgsupdator&activity=com.samsung.android.keyguardmgsupdator.ui.glance.GlancePreferenceActivity',
    },
  ],
  '8294b57a5a4a6227a45e10ab9d71ffb4': [
    {
      name: 'Settings',
      value: 'glance://settings?referrer={referrer}',
    },
    {
      name: 'Reactivation screen',
      value: 'glance://reactivation?referrer={referrer}',
    },
    {
      name: 'Reactivation API',
      value: 'glance://reactivation/enable?referrer={referrer}',
    },
  ],
  a07a917cae67e8a206bf9bdde2da9aed: [
    {
      name: 'Settings',
      value: 'glance://settings?referrer={referrer}',
    },
    {
      name: 'Reactivation screen',
      value: 'glance://reactivation?referrer={referrer}',
    },
    {
      name: 'Reactivation API',
      value: 'glance://reactivation/enable?referrer={referrer}',
    },
    {
      name: 'Shopping',
      value: 'glance://shop',
    },
    {
      name: 'Live',
      value: 'glance://live',
    },
    {
      name: 'Game',
      value: 'glance://game',
    },
    {
      name: 'Sports',
      value: 'glance://sports',
    },
    {
      name: 'Home',
      value: 'glance://home',
    },
  ],
  eee86d7cb6b40eeabd6858f4a88e4374: [
    {
      name: 'Settings',
      value: 'glance://settings?referrer={referrer}',
    },
    {
      name: 'Reactivation screen',
      value: 'glance://reactivation?referrer={referrer}',
    },
    {
      name: 'Reactivation API',
      value: 'glance://reactivation/enable?referrer={referrer}',
    },
  ],
  '8aa5e6d1bea2ee2ae3f3f148c70e4cc3': [
    {
      name: 'Settings',
      value: 'glance://settings?referrer={referrer}',
    },
    {
      name: 'Reactivation screen',
      value: 'glance://reactivation?referrer={referrer}',
    },
    {
      name: 'Reactivation API',
      value: 'glance://reactivation/enable?referrer={referrer}',
    },
    {
      name: 'Activation',
      value: 'glance://activation/enable?referrer=notification',
    },
  ],
  '6f7caac7bf84937001342b8f9641d757': [
    {
      name: 'Settings',
      value: 'glance://settings?referrer={referrer}',
    },
    {
      name: 'Reactivation screen',
      value: 'glance://reactivation?referrer={referrer}',
    },
    {
      name: 'Reactivation API',
      value: 'glance://reactivation/enable?referrer={referrer}',
    },
    {
      name: 'Activation',
      value: 'glance://activation/enable?referrer=notification',
    },
  ],
  'd41d8cd98f00b204e9800998ecf8427e': [
      {
        name: 'Settings',
        value: 'glance://settings?referrer={referrer}',
      },
      {
        name: 'Reactivation screen',
        value: 'glance://reactivation?referrer={referrer}',
      },
      {
        name: 'Reactivation API',
        value: 'glance://reactivation/enable?referrer={referrer}',
      },
      {
        name: 'Activation',
        value: 'glance://activation/enable?referrer=notification',
      },
    ],
};

const partnerRegionMap = {
  ...activePartners.reduce((a, v) => ({ ...a, [v]: [] }), {}),
  '-1': [],
};

const emptyCta = {
  text: '',
  link: '',
  id: '',
};

const targetUnitDefaultRegions = [
  { id: 'IN', name: 'India' },
  { id: 'ID', name: 'Indonesia' },
];

const targetUnitJioNextNiuRegions = [{ id: 'IN', name: 'India' }];

const targetUnitSoftbankRegions = [{ id: 'JP', name: 'Japan' },
  { id: 'US', name: 'USA' }];

const targetUnitJapanRegion = [{ id: 'JP', name: 'Japan' }];

const latamTargetUnitRegions = [
  ...targetUnitDefaultRegions,
  { id: 'BR', name: 'Brazil' },
  { id: 'MX', name: 'Mexico' },
  { id: 'CO', name: 'Columbia' },
  { id: 'US', name: 'USA' }
];

const usTargetUnitRegions = [{ id: 'US', name: 'USA' }];

const targetUnitRegions = {
  ...activePartners.reduce(
    (a, v) => ({ ...a, [v]: targetUnitDefaultRegions }),
    {},
  ),
  a07a917cae67e8a206bf9bdde2da9aed: latamTargetUnitRegions,
  '8aa5e6d1bea2ee2ae3f3f148c70e4cc3': targetUnitJioNextNiuRegions,
  '6f7caac7bf84937001342b8f9641d757': targetUnitSoftbankRegions,
  'd41d8cd98f00b204e9800998ecf8427e': usTargetUnitRegions,
  'eee86d7cb6b40eeabd6858f4a88e4374': latamTargetUnitRegions,
  'dde1b816a19d16a8b866ff74319d7995': latamTargetUnitRegions,
  'fa647c9e01a2defa9fdc483a9a3352d003cb003d': targetUnitJapanRegion,
  '-1': [],
};

interface NotificationProps {
  studioAppConfig: StudioAppConfig;
  history?: any;
}

interface cta {
  text: string;
  link: string;
}

interface NotificationState {
  partners: Partner[];
  settings: UserEngageNotification;
  actionType: string;
  urlLink: string;
  dialogOpen: boolean;
  errors: any;
  showSnackBar: boolean;
  snackBarMsg: string;
  isProcessing: boolean;
  glanceId: string;
  topicView: Boolean;
  selectedFile: any;
  uploadStatus: string;
  uploadedFileName: string;
  failureText: string;
  folderPath: string;
  notificationId: string;
  referrer: string;
  multipleCtas: boolean;
  isOptionalCta: boolean;
}

class Notification extends React.Component<
  NotificationProps,
  NotificationState
> {
  constructor(props: NotificationProps) {
    super(props);
    this.state = {
      partners: [],
      topicView: true,
      selectedFile: null,
      uploadStatus: '',
      uploadedFileName: '',
      folderPath: '',
      failureText: '',
      settings: {
        title: '',
        body: '',
        image: '',
        deeplink: '-1',
        action: '',
        alert: false,
        partnerId: '-1',
        regionId: '-1',
        testPush: false,
        sticky: false,
        targetFilePath: '',
        glanceEnabled: false,
        id: '-1',
        cta: [{ ...emptyCta }, { ...emptyCta }],
      },
      actionType: 'deepLink',
      urlLink: '',
      errors: {
        title: '',
        body: '',
        image: '',
        urlLink: '',
      },

      dialogOpen: false,
      showSnackBar: false,
      isProcessing: false,
      snackBarMsg: '',
      glanceId: '',
      referrer: '',
      notificationId: '',
      multipleCtas: false,
      isOptionalCta: false,
    };
  }

  componentDidMount() {
    // TODO: now studioAppConfig will always have a default value. this check needs to be changed
    if (!this.props.studioAppConfig) {
      this.props.history.push('/login');
      window.location.reload();
    } else {
      const partners = this.props.studioAppConfig.partners.filter((partner) => {
        return activePartners.indexOf(partner.partnerId) > -1;
      });
      this.props.studioAppConfig.partnerMetas.map((partnerMeta) => {
        if (activePartners.includes(partnerMeta.partnerId)) {
          partnerRegionMap[
            partnerMeta.partnerId
          ] = partnerMeta.supportedRegions.map((supportedRegion) => {
            return {
              id: regionFilters[supportedRegion],
              name: regionNames[supportedRegion],
            };
          });
        }
      });

      this.setState({
        ...this.state,
        partners,
      });
    }
  }

  onSettingChange = (key, value) => {
    const { errors } = this.state;

    if (key === 'title' || key === 'body' || key === 'image') {
      if (value.match(regex[key].checker)) {
        errors[key] = '';
      } else {
        errors[key] = regex[key].errMsg;
      }
    }

    if (key === 'deeplink' && value.includes('glance_id')) {
      errors[key] = regex[key].errMsg;
    }
    this.setState({
      ...this.state,
      settings: { ...this.state.settings, [key]: value },
      errors,
    });
  };

  onCtaChange = (key, value, ctaIndex) => {
    const {
      settings: { cta },
      errors,
    } = this.state;
    if (key === 'text') {
      if (value.match(regex[key].checker)) {
        errors[key + ctaIndex] = '';
      } else {
        errors[key + ctaIndex] = regex[key].errMsg;
      }
    }
    if (key === 'link') {
      if (value.match(regex[key].checker)) {
        errors[key + ctaIndex] = '';
      } else {
        errors[key + ctaIndex] = regex[key].errMsg;
      }
    }

    cta[ctaIndex] = {
      ...cta[ctaIndex],
      [key]: value,
    };

    this.setState({
      ...this.state,
      settings: { ...this.state.settings, cta },
      errors,
    });
  };

  onMultipleCtas = () => {
    this.setState({
      ...this.state,
      multipleCtas: !this.state.multipleCtas,
    });
  };

  handleClose = () => {
    this.setState({
      ...this.state,
      dialogOpen: false,
    });
  };

  publishNotification = () => {
    const {
      actionType,
      settings,
      urlLink,
      glanceId,
      referrer,
      isOptionalCta,
    } = this.state;
    const { cta } = settings;
    let deeplink = actionType === 'deepLink' ? settings.deeplink : urlLink;

    if (deeplink && deeplink.includes('glance_id')) {
      deeplink = deeplink.replace('{glance_id}', glanceId);
    }

    if (deeplink && deeplink.includes('referrer')) {
      deeplink = deeplink.replace('{referrer}', referrer);
    }

    let payload = {};
    if (!this.state.topicView) {
      if (!this.state.multipleCtas) {
        // Omit the "cta" fields
        const { cta, ...otherSettings } = settings;
        payload = {
          ...settings,
          testPush: true,
          deeplink,
          view: 'TARGETEDUSER',
        };
      } else {
        // Omit the "deeplink", "action" fields
        const { deeplink, action, ...otherSettings } = settings;
        payload = {
          ...otherSettings,
          testPush: true,
          view: 'TARGETEDUSER',
          cta: isOptionalCta ? cta : [cta[0]],
        };
      }
    } else {
      // Omit the "glanceEnabled", "targetFilePath", "cta" fields
      const { glanceEnabled, targetFilePath, cta, ...otherSettings } = settings;
      payload = { ...otherSettings, testPush: false, deeplink, view: 'TOPIC' };
    }
    this.setState({
      ...this.state,
      isProcessing: true,
      notificationId: '',
    });
    JerseyRestApiService.sendNotification(payload, (response) => {
      this.setState({
        ...this.state,
        snackBarMsg: 'Successfully Saved',
        showSnackBar: true,
        dialogOpen: false,
        isProcessing: false,
        notificationId: response.notificationId,
      });
    });
  };
  openDialog = () => {
    this.setState({
      ...this.state,
      dialogOpen: true,
      showSnackBar: false,
    });
  };
  getPartner = (partnerId) => {
    const partnerObj = this.props.studioAppConfig.partners.find(
      (partner) => partner.partnerId === partnerId,
    );
    return partnerObj ? partnerObj.name : '';
  };
  testNotification = () => {
    const {
      actionType,
      settings,
      urlLink,
      glanceId,
      referrer,
      isOptionalCta,
    } = this.state;
    const { cta } = settings;
    let deeplink = actionType === 'deepLink' ? settings.deeplink : urlLink;

    if (deeplink && deeplink.includes('glance_id')) {
      deeplink = deeplink.replace('{glance_id}', glanceId);
    }

    if (deeplink && deeplink.includes('referrer')) {
      deeplink = deeplink.replace('{referrer}', referrer);
    }

    let payload = {};
    if (!this.state.topicView) {
      if (!this.state.multipleCtas) {
        // Omit the "cta" fields
        const { cta, ...otherSettings } = settings;
        payload = {
          ...otherSettings,
          testPush: true,
          deeplink,
          view: 'TARGETEDUSER',
        };
      } else {
        // Omit the "deeplink", "action" fields
        const { deeplink, action, ...otherSettings } = settings;
        payload = {
          ...otherSettings,
          testPush: true,
          view: 'TARGETEDUSER',
          cta: isOptionalCta ? cta : [cta[0]],
        };
      }
    } else {
      // Omit the "glanceEnabled", "targetFilePath", "cta" fields
      const { glanceEnabled, targetFilePath, cta, ...otherSettings } = settings;
      payload = { ...otherSettings, testPush: true, deeplink, view: 'TOPIC' };
    }
    this.setState({
      ...this.state,
      isProcessing: true,
      showSnackBar: false,
    });
    JerseyRestApiService.sendNotification(payload, (response) => {
      this.setState({
        ...this.state,
        snackBarMsg: 'Test is Successful',
        showSnackBar: true,
        isProcessing: false,
        notificationId: response.notificationId,
      });
    });
  };

  handleActionTypeChange = (event, value) => {
    this.setState({
      ...this.state,
      actionType: value,
    });
  };

  handleOptionalCtaClick = () => {
    let { settings, errors } = this.state;
    let { cta } = settings;
    if (this.state.isOptionalCta) {
      cta[1] = { ...emptyCta };
      errors['text1'] = '';
      errors['link1'] = '';
    }

    this.setState({
      ...this.state,
      isOptionalCta: !this.state.isOptionalCta,
      settings: { ...this.state.settings, cta },
      errors,
    });
  };

  onUrlLinkChange = (urlLink) => {
    const { errors } = this.state;

    if (urlLink.match(regex['urlLink'].checker)) {
      errors['urlLink'] = '';
    } else {
      errors['urlLink'] = regex['urlLink'].errMsg;
    }

    this.setState({
      ...this.state,
      urlLink,
    });
  };

  handleSuccessClose = () => {
    this.setState({
      ...this.state,
      showSnackBar: false,
    });
  };

  onGlanceIdChange = (glanceId) => {
    this.setState({
      ...this.state,
      glanceId,
    });
  };

  onReferrerChange = (referrer) => {
    this.setState({
      ...this.state,
      referrer,
    });
  };
  handleViewClick = (e) => {
    if (e === 'topicView') {
      this.setState({
        ...this.state,
        topicView: true,
      });
    } else {
      this.setState({
        ...this.state,
        topicView: false,
        settings: {
          ...this.state.settings,
          partnerId: '6c0df13798382e1044a104a8f984edb130b20ce6',
          regionId: 'IN',
        },
      });
    }
  };
  fileSelectHandler = (event) => {
    this.setState({
      ...this.state,
      selectedFile: event.target.files,
    });
  };
  fileUploadHandler = () => {
    const { selectedFile } = this.state;
    const formData = new FormData();
    if (selectedFile && selectedFile[0].name.match(/(.csv)$/)) {
      formData.append('file', selectedFile[0]);
    } else {
      this.setState({
        ...this.state,
        uploadStatus: 'error',
        failureText: 'Only csv file type supported',
      });
      return;
    }
    if (selectedFile[0].size > FILE_UPLOAD_SIZE_LIMIT) {
      this.setState({
        ...this.state,
        uploadStatus: 'error',
        failureText: ` ${selectedFile[0].name} size is more than 70MB`,
      });
      return;
    }
    const payload = {
      formData,
    };

    const uploadFile = JerseyRestApiService.targetUserNotification(payload);
    this.setState({
      ...this.state,
      uploadStatus: 'uploading',
    });
    uploadFile
      .then((response: any) => {
        const s3Response = response;

        this.setState({
          ...this.state,
          uploadedFileName: s3Response.name,
          failureText: '',
          settings: { ...this.state.settings, targetFilePath: s3Response.path },
          uploadStatus: 'success',
        });
      })
      .catch((err) => {
        this.setState({
          ...this.state,
          uploadStatus: 'error',
          failureText: err,
        });
      });
  };
  removeUploadedFile = () => {
    this.setState({
      ...this.state,
      uploadStatus: '',
      uploadedFileName: '',
      failureText: '',
      settings: { ...this.state.settings, targetFilePath: '' },
    });
  };

  render() {
    const {
      settings: {
        title,
        body,
        image,
        action,
        sticky,
        deeplink,
        alert,
        partnerId,
        regionId,
        glanceEnabled,
        targetFilePath,
        cta,
      },
      dialogOpen,
      partners,
      errors,
      showSnackBar,
      snackBarMsg,
      isProcessing,
      actionType,
      urlLink,
      glanceId,
      topicView,
      uploadStatus,
      uploadedFileName,
      failureText,
      notificationId,
      referrer,
      multipleCtas,
      isOptionalCta,
    } = this.state;

    const isValidForm =
      title.match(regex.title.checker) &&
      body.match(regex.body.checker) &&
      ((!topicView && targetFilePath) || topicView) &&
      partnerId !== '-1' &&
      regionId !== '-1' &&
      (topicView ||
        !multipleCtas ||
        (cta[0].text.match(regex.text.checker) &&
          cta[0].link.match(regex.link.checker) &&
          (topicView ||
            !multipleCtas ||
            !isOptionalCta ||
            (isOptionalCta &&
              cta[1].text.match(regex.text.checker) &&
              cta[1].link.match(regex.link.checker))))) &&
      ((!topicView && multipleCtas) ||
        (actionType === 'deepLink' &&
          deeplink.includes('glance_id') &&
          glanceId !== '') ||
        (actionType === 'deepLink' && !deeplink.includes('glance_id')) ||
        actionType !== 'deepLink');

    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label={isProcessing ? 'Publishing...' : 'Publish'}
        primary={true}
        onTouchTap={this.publishNotification}
        disabled={isProcessing}
      />,
    ];
    const successActions = [
      <FlatButton
        label="Close"
        primary={true}
        onTouchTap={this.handleSuccessClose}
      />,
    ];
    return (
      <div>
        <Paper style={styles.container} zDepth={2}>
          <h4>Notification Settings</h4>
          <div style={styles.toggleViewContainer}>
            <span
              style={topicView ? styles.activeView : styles.inactiveview}
              onClick={() => this.handleViewClick('topicView')}
            >
              Topic
            </span>
            <span
              style={topicView ? styles.inactiveview : styles.activeView}
              onClick={this.handleViewClick}
            >
              Target Unit
            </span>
          </div>
          <GridList cols={2} padding={10} cellHeight="auto">
            <div>
              {!topicView && uploadStatus !== 'success' && !targetFilePath && (
                <div style={styles.fileUploaderView}>
                  <input
                    id="fileupload"
                    style={styles.fileUpload}
                    type="file"
                    onChange={this.fileSelectHandler}
                  />
                  <FlatButton
                    style={styles.uploadButton}
                    label={
                      uploadStatus === 'uploading' ? 'Uploading...' : 'Upload'
                    }
                    primary={true}
                    onTouchTap={this.fileUploadHandler}
                  ></FlatButton>
                </div>
              )}
              {!topicView && uploadStatus === 'success' && targetFilePath && (
                <div style={styles.uploadedFilepath}>
                  <a style={styles.filePathLink} target="_blank">
                    {uploadedFileName}
                  </a>
                  <FlatButton
                    label="Remove"
                    primary={true}
                    onTouchTap={this.removeUploadedFile}
                  ></FlatButton>
                </div>
              )}
              {!topicView && uploadStatus === 'error' && (
                <div style={styles.errorTag}>
                  {failureText
                    ? failureText
                    : 'Something went wrong. Try again'}
                </div>
              )}
            </div>
            <div></div>
          </GridList>

          <GridList cols={2} padding={10} cellHeight="auto">
            <SelectField
              fullWidth={true}
              floatingLabelText="Partners"
              value={partnerId}
              onChange={(event, index, value) =>
                this.onSettingChange('partnerId', value)
              }
            >
              <MenuItem
                value={'-1'}
                primaryText={'Select Partner'}
                key={'empty'}
              ></MenuItem>
              {topicView
                ? partners.map((item) => {
                    return (
                      <MenuItem
                        value={item.partnerId}
                        primaryText={item.name}
                        key={item.partnerId}
                      />
                    );
                  })
                : partners
                    .filter((partner) => {
                      return (
                        partner.partnerId !==
                          '16b66d7123dd588670e011bbb88bec9c0a27359c' && //Samsung Android
                        partner.partnerId !== '6ed915c905737998e3a505688863fede'
                      ); // Samsung LSS Test
                    })
                    .map((item) => {
                      return (
                        <MenuItem
                          value={item.partnerId}
                          primaryText={item.name}
                          key={item.partnerId}
                        />
                      );
                    })}
            </SelectField>

            <SelectField
              fullWidth={true}
              floatingLabelText="Regions"
              value={regionId}
              onChange={(event, index, value) =>
                this.onSettingChange('regionId', value)
              }
            >
              <MenuItem
                value={'-1'}
                primaryText={'Select Region'}
                key={'empty'}
                disabled={partnerId === '-1'}
              ></MenuItem>
              {topicView
                ? partnerRegionMap[partnerId].map((item) => {
                    return (
                      <MenuItem
                        value={item.id}
                        primaryText={item.name}
                        key={item.id}
                      />
                    );
                  })
                : targetUnitRegions[partnerId].map((item) => {
                    return (
                      <MenuItem
                        value={item.id}
                        primaryText={item.name}
                        key={item.id}
                      />
                    );
                  })}
            </SelectField>
          </GridList>

          <GridList cols={2} padding={10} cellHeight="auto">
            <TextField
              value={title}
              floatingLabelText="Title"
              onChange={(e, value) => this.onSettingChange('title', value)}
              errorText={errors.title}
              fullWidth={true}
            />

            <TextField
              value={body}
              floatingLabelText="Body"
              multiLine={true}
              rows={1}
              fullWidth={true}
              rowsMax={4}
              errorText={errors.body}
              onChange={(e, value) => this.onSettingChange('body', value)}
            />
          </GridList>

          <GridList cols={2} padding={10} cellHeight="auto">
            <TextField
              value={image}
              floatingLabelText="Image Url"
              fullWidth={true}
              errorText={errors.image}
              onChange={(e, value) => this.onSettingChange('image', value)}
            />
            <div>{/* Emppty second Col  */}</div>
          </GridList>

          {(!multipleCtas || topicView) && (
            <div>
              <GridList cols={2} padding={10} cellHeight="auto">
                <RadioButtonGroup
                  style={styles.radioButtonGroup}
                  name="actionType"
                  defaultSelected={actionType}
                  onChange={this.handleActionTypeChange}
                >
                  <RadioButton
                    value="urlLink"
                    label="Url Link"
                    style={styles.radioButton}
                  />
                  <RadioButton
                    value="deepLink"
                    label="Deep Link"
                    style={styles.radioButton}
                  />
                </RadioButtonGroup>
                <div>{/* Emppty first Col  */}</div>
              </GridList>

              <GridList cols={2} padding={10} cellHeight="auto">
                <div>
                  {actionType === 'deepLink' && (
                    <SelectField
                      floatingLabelText="Deep Link"
                      fullWidth={true}
                      value={deeplink}
                      onChange={(event, index, value) =>
                        this.onSettingChange('deeplink', value)
                      }
                      disabled={partnerId === '-1'}
                    >
                      <MenuItem
                        value={'-1'}
                        primaryText={'Select DeepLink'}
                        key={'emptydeeplink'}
                      ></MenuItem>
                      {deepLinkMap[partnerId].map((item) => {
                        return (
                          <MenuItem
                            value={item.value}
                            primaryText={item.name}
                            key={item.value}
                          />
                        );
                      })}
                    </SelectField>
                  )}
                  {actionType === 'urlLink' && (
                    <TextField
                      fullWidth={true}
                      hintText="Url Link"
                      value={urlLink}
                      errorText={errors.urlLink}
                      floatingLabelText="Url Link"
                      onChange={(e, value) => this.onUrlLinkChange(value)}
                    />
                  )}
                </div>

                <div>
                  {deeplink.includes('glance_id') &&
                    actionType === 'deepLink' && (
                      <TextField
                        fullWidth={true}
                        hintText="Glance Id"
                        value={glanceId}
                        floatingLabelText="Glance Id"
                        onChange={(e, value) => this.onGlanceIdChange(value)}
                      />
                    )}
                  {deeplink.includes('referrer') &&
                    actionType === 'deepLink' && (
                      <TextField
                        fullWidth={true}
                        hintText="Referrer"
                        value={referrer}
                        floatingLabelText="Referrer"
                        onChange={(e, value) => this.onReferrerChange(value)}
                      />
                    )}
                </div>
              </GridList>

              <GridList cols={2} padding={10} cellHeight="auto">
                <TextField
                  fullWidth={true}
                  hintText="Action"
                  value={action}
                  floatingLabelText="Action"
                  onChange={(e, value) => this.onSettingChange('action', value)}
                />
                <div>{/* Emppty second Col  */}</div>
              </GridList>
            </div>
          )}

          {!topicView && multipleCtas && (
            <GridList cols={2} padding={10} cellHeight="auto">
              <TextField
                fullWidth={true}
                hintText="CTA 1 Text"
                value={cta[0].text}
                errorText={errors.text0}
                floatingLabelText="CTA 1 Text"
                onChange={(e, value) => this.onCtaChange('text', value, 0)}
              />
              <div>
                <TextField
                  fullWidth={true}
                  hintText="CTA 1 Link"
                  value={cta[0].link}
                  errorText={errors.link0}
                  floatingLabelText="CTA 1 Link"
                  onChange={(e, value) => this.onCtaChange('link', value, 0)}
                  style={styles.ctalinkInput}
                />
                {!isOptionalCta && (
                  <IconButton
                    onClick={this.handleOptionalCtaClick}
                    style={styles.ctaIconButton}
                  >
                    <FontIcon
                      className="material-icons"
                      color={blue500}
                      style={{ fontSize: '2em' }}
                    >
                      add
                    </FontIcon>
                  </IconButton>
                )}
              </div>
            </GridList>
          )}

          {!topicView && multipleCtas && isOptionalCta && (
            <GridList cols={2} padding={10} cellHeight="auto">
              <TextField
                fullWidth={true}
                hintText="CTA 2 Text"
                value={cta[1].text}
                errorText={errors.text1}
                floatingLabelText="CTA 2 Text"
                onChange={(e, value) => this.onCtaChange('text', value, 1)}
              />
              <div>
                <TextField
                  fullWidth={true}
                  hintText="CTA 2 Link"
                  value={cta[1].link}
                  errorText={errors.link1}
                  floatingLabelText="CTA 2 Link"
                  onChange={(e, value) => this.onCtaChange('link', value, 1)}
                  style={styles.ctalinkInput}
                />
                <IconButton
                  onClick={this.handleOptionalCtaClick}
                  style={styles.ctaIconButton}
                >
                  <FontIcon
                    className="material-icons"
                    color={blue500}
                    style={{ fontSize: '2em' }}
                  >
                    remove
                  </FontIcon>
                </IconButton>
              </div>
            </GridList>
          )}

          <GridList cols={2} padding={10} cellHeight="auto">
            <Toggle
              label="Alert"
              style={styles.alertStyle}
              toggled={alert}
              onToggle={(e, value) => this.onSettingChange('alert', value)}
            />
            <Toggle
              label="Sticky"
              style={styles.alertStyle}
              toggled={sticky}
              onToggle={(e, value) => this.onSettingChange('sticky', value)}
            />
          </GridList>

          {!topicView && (
            <GridList cols={2} padding={10} cellHeight="auto">
              <Toggle
                label="GlanceEnabled"
                style={styles.alertStyle}
                toggled={glanceEnabled}
                onToggle={(e, value) =>
                  this.onSettingChange('glanceEnabled', value)
                }
              />
              <Toggle
                label="MultipleCTA's"
                style={styles.alertStyle}
                toggled={multipleCtas}
                onToggle={(e, value) => this.onMultipleCtas()}
              />
            </GridList>
          )}

          <GridList cols={2} padding={10} cellHeight="auto">
            <RaisedButton
              label={isProcessing ? 'Testing...' : 'Test'}
              fullWidth={true}
              style={styles.saveButtonStyle}
              onTouchTap={this.testNotification}
              disabled={!isValidForm || isProcessing}
            />
            <RaisedButton
              label="Publish"
              fullWidth={true}
              primary={true}
              style={styles.saveButtonStyle}
              onTouchTap={this.openDialog}
              disabled={!isValidForm || isProcessing}
            />
          </GridList>
        </Paper>
        <Dialog
          actions={actions}
          modal={false}
          open={dialogOpen}
          contentStyle={styles.dialogContentStyle}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >
          <List>
            <h4>Please Validate Below Details </h4>
            <ListItem
              primaryText="Partner"
              secondaryText={this.getPartner(partnerId)}
            />
            <ListItem primaryText="Region" secondaryText={regionId} />
            <ListItem primaryText="Title" secondaryText={title} />
            <ListItem primaryText="Body" secondaryText={body} />
            <ListItem primaryText={'Image Url'} secondaryText={image} />
            {(topicView || !multipleCtas) && (
              <ListItem
                primaryText={
                  actionType === 'deepLink' ? 'Deep Link' : 'Url Link'
                }
                secondaryText={actionType === 'deepLink' ? deeplink : urlLink}
              />
            )}
            {(topicView || !multipleCtas) && (
              <ListItem primaryText="Action" secondaryText={action} />
            )}

            {!topicView && multipleCtas && (
              <ListItem primaryText="CTA Text 1" secondaryText={cta[0].text} />
            )}
            {!topicView && multipleCtas && (
              <ListItem primaryText="CTA Link 1" secondaryText={cta[0].link} />
            )}
            {!topicView && multipleCtas && isOptionalCta && (
              <ListItem primaryText="CTA Text 2" secondaryText={cta[1].text} />
            )}
            {!topicView && multipleCtas && isOptionalCta && (
              <ListItem primaryText="CTA Link 2" secondaryText={cta[1].link} />
            )}
            <ListItem
              primaryText="Alert"
              secondaryText={alert ? 'On' : 'Off'}
            />
            <ListItem
              primaryText="Sticky"
              secondaryText={sticky ? 'On' : 'Off'}
            />
          </List>
        </Dialog>
        <Dialog
          actions={successActions}
          modal={false}
          open={showSnackBar}
          onRequestClose={this.handleSuccessClose}
        >
          Notification {notificationId} Sent Successfully
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    studioAppConfig: state.studioAppConfig,
  };
};

export default connect(mapStateToProps)(Notification);



// WEBPACK FOOTER //
// ./src/components/Notification.tsx